import { render, staticRenderFns } from "./SeguroMovilidadVMP.vue?vue&type=template&id=2d119c5a&scoped=true&"
import script from "./SeguroMovilidadVMP.vue?vue&type=script&lang=js&"
export * from "./SeguroMovilidadVMP.vue?vue&type=script&lang=js&"
import style0 from "./SeguroMovilidadVMP.vue?vue&type=style&index=0&id=2d119c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d119c5a",
  null
  
)

export default component.exports